export * as Ads from '../domains/ads/externals';
export * as Analytics from '../domains/analytics/externals';
export * as Backstage from '../domains/backstage/externals/constants';
export * as Discovery from '../domains/discovery/externals';
// TODO WEBCLIENT-6610: rename back to Listener once Listener import is removed
export * as Stats from '../domains/analytics/stats/externals';
export * as ListenerExternals from '../domains/listener/externals';
export * as Payments from '../domains/payments/externals';
export * as Playback from '../domains/playback/externals';
export * as Search from '../domains/searchT3/constants';

export const DomainNames = Object.freeze({
  Ads: 'ads',
  AudioAds: 'audioAds',
  DisplayAds: 'displayAds',
  MediaAds: 'mediaAds',
  VideoAds: 'videoAds',
  Rewards: 'rewards',

  Analytics: 'analytics',
  BranchIO: 'branchio',
  Comscore: 'comscore',
  GoogleAnalytics: 'googleAnalytics',
  GoogleTagManager: 'googleTagManager',
  Krux: 'krux',
  Stats: 'stats',

  Listener: 'listener',
  DesktopApp: 'desktopApp',
  Education: 'education',

  Payments: 'payments',
  FamilyPlanAcceptInvite: 'familyPlanAcceptInvite',
  SpecialOffers: 'specialOffers',
  Verification: 'verification',

  Playback: 'playback',
  Aps: 'aps',
  Audio: 'audio',
  Crosstab: 'crosstab',
  Drm: 'drm',
  Playlist: 'playlist',
  PlaylistT3: 'playlistT3',
  Podcast: 'podcast',
  SamplePlayer: 'sample',
  Simstream: 'simstream',
  Stations: 'stations',
  Video: 'video',
  Volume: 'volume',

  Application: 'application',
  Backstage: 'backstage',
  Catalog: 'catalog',
  Collection: 'collection',
  Debug: 'debug',
  Discovery: 'discovery',
  SearchT3: 'searchT3',
  SmartConversion: 'smartconversion',
} as const);
